const $ = require("jquery");
const ko = require("knockout");
const _find = require("lodash/find");
const download = require("downloadjs");
const ChatEventViewModel = require('./chat-event.vm');
const Dialog = require("./dialog");
require("../../scripts/custom-ko-functions");

function ChatViewModel($el, participantId, chatTarget) {
    let self = this;

    self.$dialog = $el.closest(".ws-dialog.ws-chat-dialog");
    self.$chatLog = $el.find(".ws-chat__log");
    self.$sendMessageInput = $el.find(".ws-chat__send-message-input");
    self.$sendMessageButton = $el.find(".ws-chat__send-message-button");

    self.participantId = participantId;
    self.participantNames = {};
    self.loadingChat = ko.observable(true);
    self.chatLog = ko.observableArray([]);
    self.currentMessage = ko.observable();
    self.isAgentTyping = ko.observable(false);
    self.typingUserName = ko.observable("Agent");
    self.chatInactive = ko.observable(false);
    self.agentParticipantStateActive = ko.observable(false);

    // Google Tag Manager Reporting
    let chatSessionId; 
    let chatStartTiming;
    let agentResponseTimingRecorded = false;
    let phoneLeadSent = false;
    const phoneRegex = new RegExp(/\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})?[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*/);

    self.sendMessageDisabled = ko.computed(function () {
        return self.loadingChat() || self.chatInactive();
    });

    self.isUserTyping = ko.computed(function () {
        var currentMessage = self.currentMessage();
        return currentMessage && currentMessage.length > 0;
    });

    self.isUserTyping.subscribe(function (newValue) {
        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ participantId: self.participantId, typingIndicator: !!newValue }),
            url: "/api/sitecore/ChatApi/SetTypingState",
            success: function (chatResponse) {
                self.handleChatResponse(chatResponse);
            },
            error: function () {
                self.setChatInactive(true);
            }
        });
    });

    self.poll = function () {
        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ participantId: self.participantId }),
            url: "/api/sitecore/ChatApi/Poll",
            success: function (chatResponse) {
                self.handleChatResponse(chatResponse);
            },
            error: function () {
                self.setChatInactive(true);
            }
        });
    };

    self.sendMessage = function () {
        if (self.sendMessageDisabled()) {
            return;
        }

        let messageToSend = self.currentMessage();

        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ participantId: self.participantId, message: messageToSend }),
            url: "/api/sitecore/ChatApi/SendMessage",
            success: function (chatResponse) {
                self.handleChatResponse(chatResponse);

                pushChatMessageSentGTMEvent(chatSessionId, self.participantId, "User Chat Message");
                
                if (!phoneLeadSent && phoneRegex.test(messageToSend)) {
                    pushChatPhoneLeadSentGTMEvent(chatSessionId, self.participantId);
                    phoneLeadSent = true;
                }

                if (self.chatInactive() === false) {
                    self.poll();
                }
            },
            error: function () {
                self.setChatInactive(true);
            }
        });

        self.currentMessage("");
        setTextareaRows(self.$sendMessageInput, 1);
    };

    self.getHistory = function () {
        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ participantId: self.participantId }),
            url: "/api/sitecore/ChatApi/History",
            success: function (chatHistoryResponse) {
                chatHistoryResponse.forEach((chat, index) => {
                    // The first event in the chat history should always be the "start" event, which contains the chatId
                    if (index == 0) {
                        chatSessionId = chat.chatId;
                    }
                    self.handleChatResponse(chat, true, true);
                });
                self.pollInterval = setInterval(self.poll, 2000);
                self.poll();
            },
            error: function () {
                self.setChatInactive(true);
            }
        });
    };

    self.exit = function () {
        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({ participantId: self.participantId, isChatActive: !self.chatInactive() }),
            url: "/api/sitecore/ChatApi/Exit"
        });
        clearInterval(self.pollInterval);
        self.participantId = null;
    };

    self.$dialog.on(Dialog.event.Show, function () {
        $(".ws-chat__btn").hide().prop("disabled", true);
        Dialog.maximizeChatDialog();

        self.loadingChat(true);
        self.chatInactive(false);

        if (self.participantId) {
            self.getHistory();
        }
        else {
            $.ajax({
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify({ chatTarget: chatTarget }),
                url: "/api/sitecore/ChatApi/Start",
                success: function (chatResponse) {
                    self.participantId = chatResponse.participantId;
                    phoneLeadSent = false;

                    if (chatResponse.status.type === "failure" && chatResponse.status.reason === "error.public.activeSessionAlreadyExists") {
                        self.getHistory();
                    } else if (chatResponse.status.type === "failure") {
                        self.handleChatResponse(chatResponse);
                    } else {
                        chatSessionId = chatResponse.chatId;

                        self.pollInterval = setInterval(self.poll, 2000);
                        self.poll();

                        // Start timer to record how long until CRC agent picks up the chat
                        agentResponseTimingRecorded = false;
                        chatStartTiming = performance.now();
                    }
                },
                error: function () {
                    self.setChatInactive(true);
                }
            });
        }
    });

    self.$dialog.on(Dialog.event.Hide, function () {
        $(".ws-chat__btn").show().prop("disabled", false);
        self.exit();
        self.chatLog([]);
    });

    self.getChatEvents = function (pollEventsData, useServerTimestamp = false, chatEventsFromHistory = false) {
        let chatLogArray = [];

        pollEventsData.forEach(function (item) {
            if (item.value && (item.type === "text" || item.type === "url")) {
                if (self.loadingChat()) {
                    self.loadingChat(false);
                    $("textarea.ws-material-group__input").focus();
                }

                if (!chatEventsFromHistory && item.participantType === "Agent") {
                    pushChatMessageSentGTMEvent(chatSessionId, item.participantId, "Agent Chat Message");
                    
                    if (item.type === "url") {
                        pushChatServiceUrlSentGTMEvent(chatSessionId, item.participantId);
                    }
                }

                chatLogArray.push(new ChatEventViewModel(item, self.participantId, useServerTimestamp));
            }
            else if (item.type === "participantStateChanged") {
                if (!chatEventsFromHistory && !agentResponseTimingRecorded && item.state === "active" && item.participantType === "Agent") {
                    // Record the agent connection with response time in seconds and push to Tag Manager
                    agentResponseTimingRecorded = true;
                    pushChatAgentConnectionGTMEvent(chatSessionId, item.participantId, ((performance.now() - chatStartTiming) / 1000).toFixed(1));
                }

                self.participantNames[item.participantId] = item.participantName;
            }
            else if (item.type === "typingIndicator") {
                self.isAgentTyping(item.value === "true");
                self.typingUserName(self.participantNames[item.participantId] || "Agent");
            }
        });

        self.chatLog.pushAll(chatLogArray);
        if (self.$chatLog.length) {
            self.$chatLog.scrollTop(self.$chatLog[0].scrollHeight);
        }
    };

    self.handleChatResponse = function (chatResponse, useServerTimestamp = false, chatResponseFromHistory = false) {
        if (chatResponse.status.type === "failure" && chatResponse.status.reason === "error.public.unexpectedError") {
            self.setChatInactive(true);
            return;
        }

        if (chatResponse.status.type === "failure" && chatResponse.status.reason === "error.websvc.unknownEntity.session") {
            self.setChatInactive();
            return;
        }

        if (_find(chatResponse.events, (item) => item.type === "participantStateChanged" && item.participantType === "WebUser" && item.state === "disconnected")) {
            self.getChatEvents(chatResponse.events, useServerTimestamp, chatResponseFromHistory);
            self.setChatInactive();
            return;
        }

        if (chatResponse.events && chatResponse.events.length > 0) {
            self.getChatEvents(chatResponse.events, useServerTimestamp, chatResponseFromHistory);
            //self.$chatLog.scrollTop(self.$chatLog[0].scrollHeight);
        }
    };

    self.setChatInactive = function (isServerError = false) {
        clearInterval(self.pollInterval);
        self.chatInactive(true);
        let chatInactiveMessage = isServerError
            ? "Oops, our chat service is unavailable at this time. We are working to restore this service. Please try again later. If you need immediate assistance, you can reach us by calling 877-367-9734 or sending us an email."
            : "The chat session has ended. Close and reopen chat window to start a new one.";
        let chatInactiveEvent = [new ChatEventViewModel({ "type": "text", "participantId": "00000000-0000-0000-0000-000000000000", "sequenceNumber": 99999, "conversationSequenceNumber": 0, "contentType": "text/plain", "value": chatInactiveMessage, "state": null, "participantType": "System", "displayName": "IC" })];
        self.getChatEvents(chatInactiveEvent);
        self.exit();
    };

    self.$sendMessageInput.on("keyup", function () {
        let typedTextWidth = getTextWidth($(this).val(), "normal 16px WS Variable", 0.4);
        let textAreaWidth = $(this).width();
        let rows = Math.ceil(typedTextWidth / textAreaWidth);

        setTextareaRows($(this), rows);

        if (self.$sendMessageInput.get(0).scrollHeight > self.$sendMessageInput.get(0).clientHeight){
            self.$sendMessageButton.addClass("ws-chat__send-message-scroll-button");
        }
        else if (self.$sendMessageButton.hasClass("ws-chat__send-message-scroll-button")){
            self.$sendMessageButton.removeClass("ws-chat__send-message-scroll-button");
        }
    });

    self.downloadChat = function () {
        download(self.$chatLog.html(), "chatLog.html", "text/html");
    };

    if (self.participantId) {
        Dialog.openDialog(self.$dialog);
    }
}

function getTextWidth(text, font, letterSpacing) {
    // re-use canvas object for better performance
    let canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    context.font = font;
    let metrics = context.measureText(text);
    let letterSpacingExtraWidth = text.length * letterSpacing;
    return metrics.width + letterSpacingExtraWidth;
}

function setTextareaRows($textarea, rows) {
    if (rows < 1) {
        rows = 1;
    }

    if (rows > 6) {
        rows = 6;
    }

    if (rows > 1) {
        $textarea.css("height", "auto");
    }
    else {
        $textarea.css("height", ""); // go back to page load value
    }

    $textarea.attr("rows", rows);
}

function pushChatAgentConnectionGTMEvent(chatSessionId, participantId, responseTime) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "chatAgentConnection",
        "chatSessionId": chatSessionId,
        "chatParticipantId": participantId,
        "agentResponseTime": responseTime
    });
}

function pushChatMessageSentGTMEvent(chatSessionId, participantId, chatEventAction) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "chatMessageSent",
        "chatSessionId": chatSessionId,
        "chatParticipantId": participantId,
        "chatMessageAction": chatEventAction
    });
}

function pushChatPhoneLeadSentGTMEvent(chatSessionId, participantId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "chatPhoneLeadSent",
        "chatSessionId": chatSessionId,
        "chatParticipantId": participantId
    });
}

function pushChatServiceUrlSentGTMEvent(chatSessionId, participantId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "chatServiceUrlSent",
        "chatSessionId": chatSessionId,
        "chatParticipantId": participantId
    });
}

module.exports = ChatViewModel;